<template>
  <div>
    <posts-toolbar v-model:filters="filters" />
    <posts-view-options
      v-model:filters="filters"
      v-model:pagination-mode="paginationMode"
    />

    <posts
      v-if="filters.socialSiteIds.length"
      :filters="filters"
      :persist="paginationMode === 'scroll'"
      :infinite-scroll="paginationMode === 'scroll'"
      :new-page-top="paginationMode === 'manual'"
      @total="$emit('total', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import { status } from '@/social/post/post';
import Posts from '../Posts.vue';
import PostsToolbar from '../ResponsivePostsToolbar.vue';
import PostsViewOptions from '../PostsViewOptions.vue';

interface Data {
  filters: PostFilters,
  paginationMode: string,
}

export default defineComponent({
  emits: ['total'],
  components: {
    PostsViewOptions,
    PostsToolbar,
    Posts,
  },
  data(): Data {
    return {
      filters: {
        statuses: [status.UNREVIEWED],
        socialSiteIds: [],
        categoryIds: {},
        isTrashed: false,
        since: undefined,
        until: undefined,
        mediaTypes: [],
        order: 'desc',
      },
      paginationMode: 'scroll',
    };
  },
});
</script>
